import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbThemeModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';

import {
  HeaderComponent,
  FooterComponent
} from './components';
import {
  OneColumnLayoutComponent
} from './layouts';

import { SharedModule } from '@shared/shared.module';
import { UiComponentsModule } from '../ui-components/ui-components.module';
import { ProfileService } from '@features/profile/profile.service';
import { ThemeService } from './theme.service';
import { TranslateModule } from '@ngx-translate/core';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  OneColumnLayoutComponent
];
const PIPES = [];

@NgModule({
  imports: [
    CommonModule,
    ...NB_MODULES,
    TranslateModule,
    SharedModule,
    UiComponentsModule
  ],
  exports: [CommonModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'default',
          },
          [],
        ).providers,
        ProfileService,
        ThemeService
      ],
    };
  }
}
